import { useLogout } from 'src/hooks';
import { useEffect } from 'react';

export const Logout = () => {
  const { logout } = useLogout();

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
